<template>
    <v-row class="edit_context">
        <v-col>
            <v-form lazy-validation
                    ref="user_form"
                    v-model="is_valid"
                    :disabled="locked">
                <v-row v-if="is_admin">
                    <v-col cols="12" class="title">
                        <h2>Usuário principal</h2>
                    </v-col>
                </v-row>
                <v-row v-if="is_admin">
                    <v-col cols="6">
                        <label for="gp_user">Usuário (<span>*</span>)</label>
                    </v-col>
                    <v-col cols="6">
                        <v-autocomplete color="secondary"
                                        :required="is_admin"
                                        v-model="request.userId"
                                        :items="users"
                                        item-text="fullname"
                                        item-value="userId"
                                        :rules="[(v) => !!v || 'Usuário para contexto obrigatório!']"
                                        placeholder="Selecione o usuário..."></v-autocomplete>
                    </v-col>
                </v-row>
            </v-form>
            <!-- Pagar me -->
            <v-form lazy-validation
                    ref="pm_form"
                    v-model="is_valid_pm"
                    :disabled="locked">
                <v-row>
                    <v-col cols="12" class="title">
                        <h2>Pagar.me</h2>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="pm_key">Key (<span>*</span>)</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                      required
                                      v-model="request.pagarMe.key"
                                      id="pm_key"
                                      :rules="[(v) => !!v || 'Chave Pagar Me obrigatória']"
                                      placeholder="Chave Pagar me"></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="cmd">
                    <v-col cols="12">
                        <v-row class="justify-center">
                            <v-btn color="primary"
                                   @click="updatePagarMe($event)"
                                   :disabled="!is_valid || !is_valid_pm || locked">
                                Atualizar Pagar Me
                            </v-btn>
                        </v-row>
                    </v-col>
                </v-row>
            </v-form>
            <!-- Pluggy -->
            <v-form lazy-validation
                    ref="pg_form"
                    v-model="is_valid_pg"
                    :disabled="locked">
                <v-row>
                    <v-col cols="12" class="title">
                        <h2>Pluggy</h2>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="pg_svc">Url do serviço</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                      v-model="request.pluggy.serviceUrl"
                                      id="pg_svc"
                                      placeholder="Url serviço Pluggy"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="pg_id">Identificador da conta (<span>*</span>)</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                      v-model="request.pluggy.clientId"
                                      id="pg_id"
                                      required
                                      :rules="[(v) => !!v || 'Id de conta pluggy obrigatório!']"
                                      placeholder="Id da conta Pluggy"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="pg_key">Chave da conta (<span>*</span>)</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                        v-model="request.pluggy.clientKey"
                                        id="pg_key"
                                        required
                                        :rules="[(v) => !!v || 'Chave de conta Pluggy obrigatória!']"
                                        placeholder="Chave da conta Pluggy"></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="cmd">
                    <v-col cols="12">
                        <v-row class="justify-center">
                            <v-btn color="primary"
                                   @click="updatePluggy($event)"
                                   :disabled="!is_valid || !is_valid_pg || locked">
                                Atualizar Pluggy
                            </v-btn>
                        </v-row>
                    </v-col>
                </v-row>
            </v-form>
            <!-- Email -->
            <v-form lazy-validation
                    ref="em_form"
                    v-model="is_valid_em"
                    :disabled="locked">
                <v-row>
                    <v-col cols="12" class="title">
                        <h2>E-mail</h2>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="em_smtp">Servidor SMTP (<span>*</span>)</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                      required
                                      v-model="request.email.smtp"
                                      id="em_smtp"
                                      :rules="[(v) => !!v || 'Servidor SMTP obrigatório!']"
                                      placeholder="Servidor SMTP"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="em_mail">Endereço do remetente (<span>*</span>)</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                      required
                                      v-model="request.email.email"
                                      id="em_mail"
                                      :rules="[(v) => !!v || 'Endereço de envio obrigatório']"
                                      placeholder="Endereço para mensagens enviadas"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="em_user">Usuário (autenticação) (<span>*</span>)</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                      required
                                      v-model="request.email.user"
                                      id="em_user"
                                      :rules="[(v) => !!v || 'Usuário para autenticação obrigatório!']"
                                      placeholder="Usuário para autenticação"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="em_pwd">Senha (autenticação) (<span>*</span>)</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                      required
                                      v-model="request.email.password"
                                      id="em_pwd"
                                      type="password"
                                      :rules="[(v) => !!v || 'Senha para autenticação obrigatória!']"
                                      placeholder="Senha para autenticação"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="em_port">Porta (<span>*</span>)</label>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field color="secondary"
                                      required
                                      v-model="request.email.port"
                                      id="em_smtp"
                                      type="number"
                                      :rules="[(v) => !!v && ((+v) > 0) || 'Porta deve ser número maior que zero!']"
                                      hide-spin-buttons
                                      placeholder="Porta"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <label for="em_opts">Opções de conexão (<span>*</span>)</label>
                    </v-col>
                    <v-col cols="6">
                        <v-select color="secondary"
                                  required
                                  v-model="request.email.options"
                                  :items="mailOptions"
                                  item-text="title"
                                  item-value="value"
                                  id="em_opts"
                                  :rules="[(v) => !!v || 'Opções de segurança obrigatórias!']"
                                  placeholder="Opções de segurança"></v-select>
                    </v-col>
                </v-row>
                <v-row class="cmd">
                    <v-col cols="12">
                        <v-row class="justify-center">
                            <v-btn color="primary"
                                   @click="updateEmail($event)"
                                   :disabled="!is_valid || !is_valid_em || locked">
                                Atualizar servidor de e-mail
                            </v-btn>
                        </v-row>
                    </v-col>
                </v-row>
            </v-form>
        </v-col>
    </v-row>
</template>

<style lang="css" scoped>
.edit_context h2 {
    font-size: 1rem;
}
.edit_context h3 {
    font-size: 1rem;
}
.edit_context {
    height: fit-content;
}
.edit_context button {
    width: 33.333%;
    border-radius: 10px;
    font-weight: bold;
}
.edit_context button:disabled {
    background-color: #CCCCCC;
}
.edit_context .row.cmd {
    margin-bottom: 24px;
}
</style>

<style lang="css">
.v-input {
    margin: 0;
    padding: 0;
}
.v-input .v-icon {
    cursor: default;
}
.v-input__control .v-input__slot {
    margin-bottom: 0;
}
.v-input input {
    font-size: 1rem;
    height: 1.25rem;
    padding-left: 0.5rem;
}
.row > .col {
    padding: 8px;
    vertical-align: top;
    align-content: top;
}
.col.title {
    background-color: #CCCCCC;
    color: white;
    padding: 0px 0px 0px 8px;
    margin: 0;
}
label span {
    color: red;
    font-weight: bold;
}
</style>

<script lang="js">
import client from '../../../../services/AdminService';

export default                {
    props                     : {
        locked                : { type: Boolean }
    },
    data                      () {
        return                {
            client,
            is_valid          : false,
            is_valid_pm       : false,
            is_valid_pg       : false,
            is_valid_em       : false,
            is_admin          : false,
            users             : [],
            mailOptions       : [
                {
                    title     : 'Determinar automaticamente',
                    value     : 'auto'
                },
                {
                    title     : 'Usar conexão criptografada (necessita suporte)',
                    value     : 'sslOnConnect'
                },
                {
                    title     : 'Usar envio criptografado (necessita suporte)',
                    value     : 'startTls'
                },
                {
                    title     : 'Usar envio criptografado (se disponível)',
                    value     : 'startTlsWhenAvailable'
                }
            ],
            request           : {
                userId        : '',
                pagarMe       : {
                    key       : ''
                },
                pluggy        : {
                    serviceUrl: 'https://api.pluggy.ai/',
                    clientId  : '',
                    clientKey : ''
                },
                email         : {
                    smtp      : '',
                    email     : '',
                    user      : '',
                    password  : '',
                    options   : 'auto',
                    port      : 587,
                }
            }
        }
    },
    methods                   : {
        fullStateCheck        () {
            this.is_valid     = this.$refs.user_form.validate();
            this.is_valid_pm  = this.$refs.pm_form.validate();
            this.is_valid_pg  = this.$refs.pg_form.validate();
            this.is_valid_em  = this.$refs.em_form.validate();
        },
        async updatePagarMe   (ev) {
            ev && ev.preventDefault();
            this.fullStateCheck();
            if (this.locked || !this.is_valid || !this.is_valid_pm) { return; }
            try {
                this.$emit('loading', true);
                var resp = await client.updatePagarMe(this.request.pagarMe, this.request.userId);
                if (!resp.success) {
                    this.$toast.error(resp.message || 'Falha não identificada');
                    return;
                }
                const data = resp.content;
                this.$toast.info(data && data.message || 'Atualização de configurações Pagar Me efetuada!');
                this.request.pagarMe.key = '';
                this.request.userId = '';
            } catch (e) {
                this.$toast.error(e.message || 'Erro não identificado');
            } finally {
                this.$emit('loading', false);
            }
        },
        async updatePluggy    (ev) {
            ev && ev.preventDefault();
            this.fullStateCheck();
            if (this.locked || !this.is_valid || !this.is_valid_pg) { return; }
            try {
                this.$emit('loading', true);
                var resp = await client.updatePluggy(this.request.pluggy, this.request.userId);
                if (!resp.success) {
                    this.$toast.error(resp.message || 'Falha não identificada');
                    return;
                }
                const data = resp.content;
                this.$toast.info(data && data.message || 'Atualização de configurações Pluggy efetuada!');
                this.request.pluggy.serviceUrl = '';
                this.request.pluggy.clientId   = '';
                this.request.pluggy.clientKey  = '';
            } catch (e) {
                this.$toast.error(e.message || 'Erro não identificado');
            } finally {
                this.$emit('loading', false);
            }
        },
        async updateEmail     (ev) {
            ev && ev.preventDefault();
            this.fullStateCheck();
            if (this.locked || !this.is_valid || !this.is_valid_em) { return; }
            try {
                this.$emit('loading', true);
                var resp = await client.updateEmail(this.request.email, this.request.userId);
                if (!resp.success) {
                    this.$toast.error(resp.message || 'Falha não identificada');
                    return;
                }
                const data = resp.content;
                this.$toast.info(data && data.message || 'Atualização de configurações de servidor de e-mail efetuada!');
                this.request.email.smtp     = '';
                this.request.email.email    = '';
                this.request.email.user     = '';
                this.request.email.password = '';
                this.request.email.port     = 587;
                this.request.email.options  = 'auto';
            } catch (e) {
                this.$toast.error(e.message || 'Erro não identificado');
            } finally {
                this.$emit('loading', false);
            }
        },
        async getUsers        () {
            if (this.locked) { return; }
            try {
                this.$emit('loading', true);
                const resp = await this.client.getContextUsers();
                if (!resp.success) {
                    this.$toast.error(resp.message || 'Falha não identificada');
                    return;
                }
                const data = resp.content;
                this.users.length = 0;
                this.users.push(...data);
            } catch (e) {
                this.$toast.error(e.message || 'Erro não identificado');
            } finally {
                this.$emit('loading', false);
            }
        }
    },
    computed                  : {
        emailPort             () {
            return this.request.email.port;
        }
    },
    watch                     : {
        emailPort             (value) {
            if (typeof value === 'string') {
                this.request.email.port = value && (+value) || 0;
            }
        }
    },
    mounted                   () {
        this.is_admin         = this.$store &&
                                this.$store.getters &&
                                this.$store.getters.$user &&
                                this.$store.getters.$user.systemRoleId &&
                                this.$store.getters.$user.systemRoleId === 1 ||
                                false;
        if (this.is_admin) {
            return this.getUsers();
        }
        return Promise.resolve();
    }
}
</script>